/**
 * Tester token management.
 * Generates and persists a unique token in a cookie so feedback items
 * can be linked to a tester across sessions (without auth).
 */
const COOKIE_NAME = 'fh_tester_token';
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year

export function getTesterToken(): string {
  const existing = getCookie(COOKIE_NAME);
  if (existing) return existing;

  const token = generateToken();
  setCookie(COOKIE_NAME, token, COOKIE_MAX_AGE);
  return token;
}

function generateToken(): string {
  // Crypto-random UUID if available, otherwise fallback
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'fh-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name: string, value: string, maxAge: number): void {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}
